import {createSlice} from "@reduxjs/toolkit";

const initialHatcheryOwnersState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  hatcheryOwnerForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const hatcheryOwnersSlice = createSlice({
  name: "hatcheryOwners",
  initialState: initialHatcheryOwnersState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getHatcheryOwnerById
    hatcheryOwnerFetched: (state, action) => {
      state.actionsLoading = false;
      state.hatcheryOwnerForEdit = action.payload.hatcheryOwnerForEdit;
      state.error = null;
    },
    // findHatcheryOwners
    hatcheryOwnersFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    pastHatcheryOwnersFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createHatcheryOwner
    hatcheryOwnerCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.hatcheryOwner);
    },
    // updateHatcheryOwner
    hatcheryOwnerUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.id === action.payload.hatcheryOwner.id) {
          return action.payload.hatcheryOwner;
        }
        return entity;
      });
    },
    // deleteHatcheryOwner
    hatcheryOwnerDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.id !== action.payload.id);
    },
    // deleteHatcheryOwners
    hatcheryOwnersDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.id)
      );
    },
    // hatcheryOwnersUpdateState
    hatcheryOwnersStatusUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map(entity => {
        if (ids.findIndex(id => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    }
  }
});
